<!--是、否选项的评价计分板 -- 评价 -->
<template>
  <a-table :columns="columns"
           :data-source="dataSource"
           :loading="loading"
           :pagination="false">

    <a-form-model
      ref="form"
      slot="evalResult"
      slot-scope="text,record"
      :ref="record.index"
      :model="record"
      style="width:200px;height:40px">
      <a-form-model-item prop="evalResult">
        <a-select :disabled="inputDisabled" style="width:200px; left: 50%; margin-left: -125px" v-model="record.evalResult">
          <a-select-option value="true">是</a-select-option>
          <a-select-option value="false">否</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-table>
</template>

<script>
import {clone} from "xe-utils/methods";

export default {
  name: "OptionScoreBoard",
  props: ["evalClauseWithOption", "loading", 'inputDisabled'],
  watch: {
    loading(newVal, oldVal) {
      this.loading = newVal
    }
  },
  created() {
    if (this.evalClauseWithOption) {
      // 这边要拷贝，不能直接赋值，影响到父组件中其他子组件结果
      this.dataSource = clone(this.evalClauseWithOption, true)
    }
  },
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'sortNo',
          key: 'sortNo',
          width: 60,
          align: "center"
        },
        {
          title: '违法违规行为',
          dataIndex: 'evalContent',
          width: '600px',
          key: 'evalContent',
          // align: 'center',
          scopedSlots: {customRender: 'evalContent'}
        },
        {
          title: '是否存在违法违规情况',
          dataIndex: 'evalResult',
          width: '200px',
          key: 'evalResult',
          align: 'center',
          scopedSlots: {customRender: 'evalResult'}
        }],
      dataSource: [],

    }
  },
  methods: {
    autoInputResult() {
      for (let item of this.dataSource) {
        this.$set(item, 'evalResult', "false")
      }
    },
  }
}
</script>

<style scoped>
>>> .ant-table-thead > tr > th {
  text-align: center;
}
</style>